/**
 * Vocabulario común de las pantallas de caja.
 *
 * Lo usan el cierre (views/dashboard/cashregister/CloseCashRegister.js), el
 * historial (CashRegisterReport.js) y el arqueo (CashAuditPanel.js). Antes cada
 * una traía su propia copia de estas constantes y ya habían empezado a
 * divergir: el cierre traducía `paypal`, el historial no, y los símbolos de
 * moneda estaban escritos tres veces.
 */

export const METHOD_LABELS = {
  cash: 'Efectivo',
  card: 'Tarjeta',
  transfer: 'Transferencia',
  zelle: 'Zelle',
  other: 'Otro'
};

export const CURRENCY_SYMBOLS = { USD: '$', VES: 'Bs.', BsF: 'Bs.', COP: '$', MXN: '$', EUR: '€' };

/** Nombre legible de un método, tolerante a mayúsculas y valores desconocidos. */
export const methodLabel = (method) => METHOD_LABELS[String(method || '').toLowerCase()] || method || '—';

export const money = (amount, currency) =>
  `${CURRENCY_SYMBOLS[currency] || currency} ${Number(amount || 0).toLocaleString('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;

export const dateTime = (value) =>
  value
    ? new Date(value).toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    : '—';

/**
 * Números monetarios: siempre tabulares.
 *
 * Hace que todos los dígitos ocupen el mismo ancho, así las cifras de una
 * columna se alinean y se pueden comparar de un vistazo. En una planilla de
 * caja no es cosmético.
 */
export const numeric = { fontVariantNumeric: 'tabular-nums' };
